import React from "react";
import { SesionScreen } from "./SesionScreen";
import { UpdatePasswordScreen } from "./UpdatePasswordScreen";
import { MFAScreen } from "./MFAScreen";

import { Route, BrowserRouter as Router, Switch } from "react-router-dom";


export const LoginScreen = () => {
  return (
    <>
      <div id="login-container"></div>
      <div id="form-login">
        <div className="form-login-tractor">
          <div className="form-login-tractor-efect"></div>
        </div>
        <div className="form-content">
          <div className="form-content-header">HUMAYA DIGITAL</div>
          <Router>
            <Switch>
              <Route path={`/auth/login`} component={SesionScreen} />
              <Route path={`/auth/multifactor`} component={MFAScreen} />
              <Route
                path={`/auth/updatepassword`}
                component={UpdatePasswordScreen}
              />
            </Switch>
          </Router>
        </div>
      </div>
    </>
  );
};
